import {onReady, onScroll} from "./functions";

function headerScroll(self) {
	let $sticky = document.querySelector('.vg-hdr'),
		scroll = self.scrollY;

	if (!$sticky) return;

	if (scroll > 0) {
		$sticky.classList.add('fixed');
	} else {
		$sticky.classList.remove('fixed');
	}
}

function fixedScrollTo(self) {
	let $sticky = document.querySelector('.vg-scroll-top'),
		scroll = self.scrollY;

	if (!$sticky) return;

	if (scroll > 400) {
		$sticky.classList.add('is-active');
	} else {
		$sticky.classList.remove('is-active');
	}

	return false;
}

window.addEventListener('scroll', function (event) {
	headerScroll(this)
	fixedScrollTo(this)
});
window.addEventListener('DOMContentLoaded', function (event) {
	headerScroll(this)
	fixedScrollTo(this)
});
